import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiPlace\DeleteWikiPlaceController::deleteMethod
* @see app/Http/Controllers/WikiPlace/DeleteWikiPlaceController.php
* @route '/api/place/delete/{wiki_place}'
*/
export const deleteMethod = (args: { wiki_place: string | number } | [wiki_place: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/place/delete/{wiki_place}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\WikiPlace\DeleteWikiPlaceController::deleteMethod
* @see app/Http/Controllers/WikiPlace/DeleteWikiPlaceController.php
* @route '/api/place/delete/{wiki_place}'
*/
deleteMethod.url = (args: { wiki_place: string | number } | [wiki_place: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { wiki_place: args }
    }

    if (Array.isArray(args)) {
        args = {
            wiki_place: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        wiki_place: args.wiki_place,
    }

    return deleteMethod.definition.url
            .replace('{wiki_place}', parsedArgs.wiki_place.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiPlace\DeleteWikiPlaceController::deleteMethod
* @see app/Http/Controllers/WikiPlace/DeleteWikiPlaceController.php
* @route '/api/place/delete/{wiki_place}'
*/
deleteMethod.delete = (args: { wiki_place: string | number } | [wiki_place: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\WikiPlace\DeleteWikiPlaceController::undo
* @see app/Http/Controllers/WikiPlace/DeleteWikiPlaceController.php
* @route '/api/place/undo-delete/{wiki_place}'
*/
export const undo = (args: { wiki_place: string | number } | [wiki_place: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/place/undo-delete/{wiki_place}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiPlace\DeleteWikiPlaceController::undo
* @see app/Http/Controllers/WikiPlace/DeleteWikiPlaceController.php
* @route '/api/place/undo-delete/{wiki_place}'
*/
undo.url = (args: { wiki_place: string | number } | [wiki_place: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { wiki_place: args }
    }

    if (Array.isArray(args)) {
        args = {
            wiki_place: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        wiki_place: args.wiki_place,
    }

    return undo.definition.url
            .replace('{wiki_place}', parsedArgs.wiki_place.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiPlace\DeleteWikiPlaceController::undo
* @see app/Http/Controllers/WikiPlace/DeleteWikiPlaceController.php
* @route '/api/place/undo-delete/{wiki_place}'
*/
undo.get = (args: { wiki_place: string | number } | [wiki_place: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiPlace\DeleteWikiPlaceController::undo
* @see app/Http/Controllers/WikiPlace/DeleteWikiPlaceController.php
* @route '/api/place/undo-delete/{wiki_place}'
*/
undo.head = (args: { wiki_place: string | number } | [wiki_place: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteWikiPlaceController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteWikiPlaceController